// src/pages/support/components/Field.jsx
import React from "react";

function Field({ label, children }) {
  return (
    <label className="block">
      <div className="text-sm text-gray-300 mb-1">{label}</div>
      {children}
    </label>
  );
}

export default Field;